import { useHistory } from 'react-router-dom'
import to from 'await-catch'
import { logout } from '../api'
import { patientDefaults } from '../reducers'


export const useLogout = (setPatientDetails, logoutAction) => {
	const history = useHistory()

	const handleLogout = async () => {
		await to(logout())
		setPatientDetails(patientDefaults)
		logoutAction()
		history.push('/')
	}

	return handleLogout
}
